import request from "./request";
import apis from "./apis";

const {
  signIn,
  logout,
} = apis.login;

const login = {
  signIn: (data: Object) => {
    return request.post(signIn, data);
  },
  logout: () => {
    return request.post(logout);
  },
};

export default login;